import { render } from "./FatturePratiche.vue?vue&type=template&id=48048e66&scoped=true"
import script from "./FatturePratiche.vue?vue&type=script&lang=js"
export * from "./FatturePratiche.vue?vue&type=script&lang=js"

import "./FatturePratiche.vue?vue&type=style&index=0&id=48048e66&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48048e66"]])

export default __exports__